import $ from 'jquery';

$('.js-filter').each((index, filter) => {
  const $filter = $('.js-filter');
  const $category = $filter.find('[name="category"]');
  const $keyword = $filter.find('[name="keyword"]');

  // Instead of submitting the form, redirect to the "results" page.
  $filter.on('submit', event => {
    event.preventDefault();
    const category = $category.val();
    const keyword = $keyword.val();
    if (keyword) {
      window.location.href = `${category}?keyword=${keyword}`;
    } else {
      window.location.href = category;
    }
  });

  // Automatically trigger submit (redirect) on dropdown change, as there's no
  // "submit" button (aside from the search magnifying glass).
  $category.on('change', () => $filter.submit());
});
